import React from "react";

export default function Marquee() {
  const items = ["Modular Kitchens", "Wardrobes", "False Ceiling", "Flooring", "Painting", "Storage", "Wall Decor", "Turnkey Interiors"];
  const row = [...items, ...items];
  return (
    <section className="py-10 md:py-14 bg-navy text-warm overflow-hidden border-y border-warm/10" data-testid="marquee">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="mx-8 md:mx-12 font-display text-3xl md:text-5xl font-light tracking-tight inline-flex items-center gap-8 md:gap-12">
            {t}
            <span className="text-terracotta text-xl md:text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
